<template>
  <v-dialog v-model="showDialog" persistent scrollable max-width="900px">
    <v-card>
      <v-toolbar dark class="primary elevation-4">
        <h2 class="pt-1">{{ edditing ? $t("edit_guest") : $t("add_guest") }}</h2>
        <v-spacer></v-spacer>
        <v-tooltip top class="mr-3" v-if="edditing">
          <v-btn icon slot="activator" @click="deleteGuest">
            <v-icon>delete</v-icon>
          </v-btn>
          <span>{{ $t("guest_delete_tooltip") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn icon slot="activator" @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <span>{{ $t("close") }}</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex xs12 md7 class="pa-4 grey lighten-4 elevation-3">
              <h4 class="accent--text">{{ $t("guest_information")|upper }}</h4>

              <v-layout row>
                <v-flex xs6 class="pr-3">
                  <v-text-field
                    name="first_name"
                    v-model="first_name"
                    :label="$t('first_name')"
                    autofocus
                    ref="focus"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pl-3">
                  <v-text-field
                    name="last_name"
                    v-model="last_name"
                    :label="$t('last_name')"
                    :rules="[() => !!last_name || $t('required_field')]"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="pr-3">
                  <CountrySelect :country.sync="country" :required="true"></CountrySelect>
                </v-flex>
                <v-flex xs6 class="pl-3">
                  <v-text-field
                    name="city"
                    v-model="city"
                    :label="$t('city')"
                    :rules="[() => !!city || $t('required_field')]"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <h4 class="mt-4 accent--text"><b>{{ $t("unique_information")|upper }}</b></h4>
              <v-layout row>
                <v-flex xs6 class="pr-3">
                  <v-text-field
                    name="document_id"
                    v-model="document_id"
                    :label="$t('document_id')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pl-3">
                  <v-text-field
                    name="visum_number"
                    v-model="visum_number"
                    :label="$t('visum_number')"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <h4 class="mt-4 accent--text"><b>{{ $t("contact_data")|upper }}</b></h4>
              <v-layout row>
                <v-flex xs6 class="pr-3">
                  <v-text-field
                    name="email"
                    v-model="email"
                    :label="$t('email')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pl-3">
                  <v-text-field
                    name="phone"
                    v-model="phone"
                    :label="$t('phone')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>



            <v-flex xs12 md5 class="pa-4">
              <h4 class="accent--text">{{ $t("report_reason")|upper }}</h4>
              <p>{{ $t("choose_report_reasons") }}</p>
              <TagReasonSelect :tags.sync="tags" :required="true"></TagReasonSelect>

              <p class="mt-3 accent--text">{{ $t("your_note")|upper }}</p>
              <v-textarea
                  name="note"
                  v-model="note"
                  :label="$t('note')"
                  :rows="10"
              ></v-textarea>

              <v-layout class="mt-3" v-show="guest === null">
                <v-flex xs1>
                  <v-checkbox
                    v-model="licence_agree"
                    color="primary"
                    >
                  </v-checkbox>
                </v-flex>
                <v-flex xs11>
                  <small class="grey--text lighten-2"><b>
                    <tac-dialog :showDialog="showTacDialog" @closeDialog="showTacDialog = false"></tac-dialog>
                    <p class="compress_lines" @click.stop="showTacDialog = true">{{ $t("licence_agree") }}</p>
                    <!--<p class="compress_lines">{{ $t("licence_agree_1") }}</p>-->
                    <!--<p class="compress_lines">{{ $t("licence_agree_2") }}</p>-->
                    <!--<p class="compress_lines">{{ $t("licence_agree_3") }}</p>-->
                  </b></small>
                </v-flex>
              </v-layout>

              <v-btn class="mt-4" color="accent" dark style="width:100%;" @click="onSave">
                {{ (guest === null ? $t("report_guest") : $t("update_guest"))|upper }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import CountrySelect from '../components/CountrySelect'
  import TacDialog from '../components/TacDialog'
  import TagReasonSelect from '../components/TagReasonSelect'
  import * as utils from '../../utils'

  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      guest: {
        default: null
      }
    },
    components: {
      CountrySelect,
      TagReasonSelect,
      'tac-dialog': TacDialog
    },

    data () {
      return {
        first_name: '',
        middle_name: '',
        last_name: '',
        street: '',
        city: '',
        zip: '',
        country: '',
        company: '',
        company_possition: '',
        email: '',
        email_tag: '',
        phone: '',
        phone_tag: '',
        birthdate: null,
        document_id: '',
        visum_number: '',
        note: '',
        image_url: '',
        image: null,
        tags: [],

        licence_agree: false,
        showTacDialog: false
      }
    },

    computed: {
      edditing () {
        return this.guest && this.guest.id
      }
    },

    watch: {
      showDialog (value) {
        if (value && this.guest !== null) {
          this.first_name = this.guest.first_name
          this.middle_name = this.guest.middle_name
          this.last_name = this.guest.last_name
          this.street = this.guest.street
          this.city = this.guest.city
          this.zip = this.guest.zip
          this.country = this.guest.country
          this.company = this.guest.company
          this.company_possition = this.guest.company_possition
          this.email = this.guest.email
          this.email_tag = this.guest.email_tag
          this.phone = this.guest.phone
          this.phone_tag = this.guest.phone_tag
          this.birthdate = this.guest.birthdate
          this.document_id = this.guest.document_id
          this.visum_number = this.guest.visum_number
          this.note = this.guest.note
          this.tags = this.guest.tags
        } else {
          this.first_name = ''
          this.middle_name = ''
          this.last_name = ''
          this.street = ''
          this.city = ''
          this.zip = ''
          this.country = ''
          this.company = ''
          this.company_possition = ''
          this.email = ''
          this.email_tag = ''
          this.phone = ''
          this.phone_tag = ''
          this.birthdate = null
          this.document_id = ''
          this.visum_number = ''
          this.note = ''
          this.tags = []
        }
        if (value) {
          requestAnimationFrame(() => {
            this.$refs.focus.focus()
          })
        }
      }
    },

    methods: {
      onSave () {
        // Souhlas s licenci, pokud zakladam noveho hosta.
        if (this.guest === null && !this.licence_agree) {
          this.$swal({
            title: this.$t('warning'),
            text: this.$t('add_guest_licence_agree'),
            type: 'warning'
          })
          return
        }
        // Musi byt vyplneny povinne udaje.
        if (this.last_name.trim() === '' || this.country.trim() === '' || this.city.trim() === '' ||
            (this.document_id.trim() === '' && this.email.trim() === '' && this.visum_number.trim() === '')) {
          this.$swal({
            title: this.$t('warning'),
            text: this.$t('add_guest_required_data'),
            type: 'warning'
          })
          return
        }
        // Musi byt vyplnen duvod hlaseni.
        if (this.tags.length === 0) {
          this.$swal({
            title: this.$t('warning'),
            text: this.$t('add_guest_add_tag'),
            type: 'warning'
          })
          return
        }

        const guest = {
          first_name: this.first_name,
          middle_name: this.middle_name,
          last_name: this.last_name,
          street: this.street,
          city: this.city,
          zip: this.zip,
          country: this.country,
          company: this.company,
          email: this.email,
          phone: this.phone,
          document_id: this.document_id,
          visum_number: this.visum_number,
          note: this.note,
          tags: this.tags
        }

        if (this.guest && this.guest.id) {
          utils.HTTP.put('guest/' + this.guest.id, guest)
            .then(result => {
              if (result.status < 0) {
                throw new Error(result.message)
              }
              guest.id = this.guest.id
              this.closeDialog(guest)
            })
            .catch(error => {
              console.log('ERROR GuestDialog onSave: ' + error)
              this.$notify({
                group: 'app',
                type: 'error',
                text: '<center>' + this.$t('add_guest_save_error') + ': ' + error.message + '</center>',
                duration: 2000
              })
            })
        } else {
          utils.HTTP.post('guest', guest)
            .then(result => {
              if (result.status < 0) {
                throw new Error(result.message)
              }
              this.closeDialog(null)
            })
            .catch(error => {
              console.log('ERROR GuestDialog onSave: ' + error)
              utils.showError(this, this.$t('add_guest_save_error') + ': ' + error.message)
            })
        }
      },

      deleteGuest () {
        if (!this.guest || !this.guest.id) {
          return
        }
        this.$swal({
          text: this.$t('delete_guest'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: this.$t('delete'),
          cancelButtonText: this.$t('no')
        }).then(result => {
          if (result.value) {
            utils.HTTP.delete('guest/' + this.guest.id)
              .then(result => {
                if (result.status < 0) {
                  throw new Error(result.message)
                }
                this.closeDialog('deleted')
              })
              .catch(error => {
                console.log('ERROR GuestDialog onDelete: ' + error)
                utils.showError(this, error.message)
              })
          }
        })
      },

      closeDialog (guest) {
        this.$emit('closeDialog', guest)
      }
    }
  }
</script>

<style scoped>
.compress_lines {
  margin: 0;
  padding: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Guests/GuestDialog.vue